import { Container, Content01 } from '@/atoms';
import { CardBlog, Hero, SliderProduct } from '@/molecules';

import { GetStaticPropsContext, GetStaticPropsResult } from 'next';

import { ProductBlock, SliderHero } from '@/organisms';
import { ButtonVariant } from '@/atoms/button/types';
import { highlightedPageLimit, revalidateTimeout } from '@/lib/constants';
import { drupal } from '@/utils/drupal/drupal';
import { getGlobalElements } from '@/utils/drupal/get-global-elements';
import { getParams } from '@/utils/drupal/get-params';
import { DrupalNode } from 'next-drupal';
import { NodePageProps } from 'pages/[...slug]';
import { ProductBlockShopify } from '@/templates';


import { routes } from '@/lib/routes';

import {
  Size as SizeBlog,
  Variation as VariationBlog,
} from '@/molecules/card-blog/types';
import Link from 'next/link';
import { getUrlFromMedia } from '@/utils/utils';
import Layout from '@/components/layouts/Layout';
import { useEffect, useState } from 'react';
import { getResourcePath } from '@/utils/drupal/get-resource-path';
import getContent from '@/utils/drupal/get-content';


export default function EscuelaJamon({
  content,
  preFooter,
  blocks,
  theme,
  meta,
  canonical

}: NodePageProps) {

  // nosemgrep: nodejs_scan.javascript-crypto-rule-node_insecure_random_generator
  const posts = content.views.content.sort(() => 0.5 - Math.random())
  // nosemgrep: nodejs_scan.javascript-crypto-rule-node_insecure_random_generator
  const heroPosts = content.views.highlightedContent;
  const curiosities = posts.filter((item) => item.field_category.name === 'Curiosidades de los ibéricos').slice(0, 3);
  const experts = posts.filter((item) => item.field_category.name === 'El Experto Responde').slice(0, 3);
  const moments = posts.filter((item) => item.field_category.name === 'Momentos Navidul').slice(0, 3);
  const nutritionAndBalance = posts.filter((item) => item.field_category.name === 'Nutrición y equilibrio').slice(0, 3);

  const highlightedPost = posts.slice(0, 3);

  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])


  return (
    <Layout blocks={blocks} theme={theme ? 'dark' : 'light'} layoutType='base' preFooter={preFooter} meta={meta} canonical={canonical}>
      {isClient ?
        <div className="pt-header">
          <Container wrapper wrapperSize="max-w-[790px]">
            <Content01
              pretitle="ESCUELA DEL JAMÓN"
              title="Descubre las recetas y secretos más cotizados del jamón"
              position="center"
              typeTitle="h1"
            />
          </Container>

          <Container wrapper>
            <SliderHero>
              {heroPosts.map((post: any, index: number) => (
                <SliderHero.Slide key={index}>
                  <Hero
                    backgroundImage={getUrlFromMedia(post.field_image)}
                    overlay={0.5}
                    theme="dark"
                    className="!p-10"
                  >
                    <Hero.Title>{post.title}</Hero.Title>
                    <Hero.Button href={post.path.alias} variant={ButtonVariant.DISPLAY}>
                      Ver post
                    </Hero.Button>
                  </Hero>
                </SliderHero.Slide>
              ))}
            </SliderHero>
          </Container>

          <Container wrapper>
            <ProductBlock
              title="Curiosidades de los ibéricos"
              textlink="Ver todos los artículos"
              href={routes.blog.item('cerdo-jamon-iberico')}
            >
              <SliderProduct
                perPage={3}
                breakpoints={{
                  1024: {
                    perPage: 3,
                  },
                  768: {
                    padding: 45,
                    perPage: 2,
                  },
                  500: {
                    padding: 45,
                    perPage: 1,
                  },
                }}
              >
                {curiosities.map((post: any, index: number) => (
                  <CardBlog
                    image={{ src: getUrlFromMedia(post.field_image) }}
                    size={SizeBlog.SMALL}
                    variation={VariationBlog.DEFAULT}
                    key={index}
                  >
                    <CardBlog.Pretitle position="left">
                      {/* Ellos no tenian puesto nada */}
                    </CardBlog.Pretitle>
                    <CardBlog.Title>
                      <Link href={post.path.alias}>
                        <h3>{post.title}</h3>
                      </Link>
                    </CardBlog.Title>
                    {post.body?.summary && (
                      <CardBlog.Description>
                        {post.body.summary}
                      </CardBlog.Description>
                    )}
                    <CardBlog.Link href={post.path.alias}>Leer</CardBlog.Link>
                  </CardBlog>
                ))}
              </SliderProduct>
            </ProductBlock>
          </Container>

          <Container wrapper>
            <ProductBlock
              title="El experto responde"
              textlink="Ver todos los artículos"
              href={routes.blog.item('el-experto-responde')}
            >
              <SliderProduct
                perPage={3}
                breakpoints={{
                  1024: {
                    perPage: 3,
                  },
                  768: {
                    padding: 45,
                    perPage: 2,
                  },
                  500: {
                    padding: 45,
                    perPage: 1,
                  },
                }}
              >
                {experts.map((post: any, index: number) => (
                  <CardBlog
                    image={{ src: getUrlFromMedia(post.field_image) }}
                    size={SizeBlog.MEDIUM}
                    variation={VariationBlog.DEFAULT}
                    key={index}
                  >
                    <CardBlog.Title>
                      <Link href={post.path.alias}>
                        <h3>{post.title}</h3>
                      </Link>
                    </CardBlog.Title>
                    {post.body?.summary && (
                      <CardBlog.Description>
                        {post.body.summary}
                      </CardBlog.Description>
                    )}
                    <CardBlog.Link href={post.path.alias}>Ver más</CardBlog.Link>
                  </CardBlog>
                ))}
              </SliderProduct>
            </ProductBlock>
          </Container>

          <Container wrapper>
            <ProductBlock
              title="Momentos Navidul"
              textlink="Ver todos los artículos"
              href={routes.blog.item('momentos-navidul')}
            >
              <SliderProduct
                perPage={3}
                breakpoints={{
                  1024: {
                    perPage: 3,
                  },
                  768: {
                    padding: 45,
                    perPage: 2,
                  },
                  500: {
                    padding: 45,
                    perPage: 1,
                  },
                }}
              >
                {moments.map((post: any, index: number) => (
                  <CardBlog
                    image={{ src: getUrlFromMedia(post.field_image) }}
                    size={SizeBlog.SMALL}
                    variation={VariationBlog.DEFAULT}
                    key={index}
                  >
                    <CardBlog.Pretitle position="left">
                      {/* {post.categoriasNuevas[0].name} Ellos no tienen puesto nada*/}
                    </CardBlog.Pretitle>
                    <CardBlog.Title>
                      <Link href={post.path.alias}>
                        <h3>{post.title}</h3>
                      </Link>
                    </CardBlog.Title>
                    {post.body?.summary && (
                      <CardBlog.Description>{post.body.summ}</CardBlog.Description>
                    )}
                    <CardBlog.Link href={post.path.alias}>Leer</CardBlog.Link>
                  </CardBlog>
                ))}
              </SliderProduct>
            </ProductBlock>
          </Container>

          {
            nutritionAndBalance.length > 0 &&
            <Container wrapper>
              <ProductBlock
                title="Nutrición y equilibrio"
                textlink="Ver todos los artículos"
                href={routes.blog.item('nutricion-y-equilibrio')}
              >
                <SliderProduct
                  perPage={3}
                  breakpoints={{
                    1024: {
                      perPage: 3,
                    },
                    768: {
                      padding: 45,
                      perPage: 2,
                    },
                    500: {
                      padding: 45,
                      perPage: 1,
                    },
                  }}
                >
                  {nutritionAndBalance.map((post: any, index: number) => (
                    <CardBlog
                      image={{ src: getUrlFromMedia(post.field_image) }}
                      size={SizeBlog.MEDIUM}
                      variation={VariationBlog.DEFAULT}
                      key={index}
                    >
                      <CardBlog.Pretitle position="left">
                        {/* {post.categoriasNuevas[0].name} Ellos no tienen puesto nada*/}
                      </CardBlog.Pretitle>
                      <CardBlog.Title>
                        <Link href={post.path.alias}>
                          <h3>{post.title}</h3>
                        </Link>
                      </CardBlog.Title>
                      {post.body?.summary && (
                        <CardBlog.Description>{post.body.summ}</CardBlog.Description>
                      )}
                      <CardBlog.Link href={post.path.alias}>Leer</CardBlog.Link>
                    </CardBlog>
                  ))}
                </SliderProduct>
              </ProductBlock>
            </Container>
          }

          <Container wrapper>
            <ProductBlock title="Artículos populares">
              <SliderProduct
                perPage={3}
                breakpoints={{
                  1024: {
                    perPage: 3,
                  },
                  768: {
                    padding: 45,
                    perPage: 2,
                  },
                  500: {
                    padding: 45,
                    perPage: 1,
                  },
                }}
              >
                {highlightedPost.map((post: any, index: number) => (
                  <CardBlog
                    image={{ src: getUrlFromMedia(post?.field_image) }}
                    size={SizeBlog.LARGE}
                    variation={VariationBlog.DISPLAY}
                    key={index}
                  >
                    <CardBlog.Pretitle position="left">
                      {post.field_category.name}
                    </CardBlog.Pretitle>
                    <CardBlog.Title>
                      <Link href={post.path.alias}>
                        {post.title}
                      </Link>
                    </CardBlog.Title>
                    <CardBlog.Link href={post.path.alias}>Leer</CardBlog.Link>
                  </CardBlog>
                ))}
              </SliderProduct>
            </ProductBlock>
          </Container>

          <Container wrapper>
            <ProductBlockShopify
              shopifyCategory="destacados"
              shopifyProducts={content.views.products}
              title="Te puede interesar"
            />
          </Container>
        </div > : null}
    </Layout>
  );
};

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<NodePageProps>> {
  const slug = "/es/escuela-del-jamon"
  const path = await drupal.translatePath(slug);
  const resource = await getResourcePath(path, context);
  if (resource == null) {
    return {
      notFound: true,
      revalidate: revalidateTimeout
    };

  }
  const type = path.jsonapi?.resourceName;
  const contentObject = await getContent(resource, type, context);

  contentObject.content.views.highlightedContent = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "node--article", context, {
    params: getParams("node--article", "card")
      .addSort("created", "DESC")
      .addFilter("promote", "1")
      .addPageLimit(highlightedPageLimit)
      .getQueryObject(),
  });
  contentObject.content.views.content = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "node--article", context, {
    params: getParams("node--article", "card")
      .addSort("created", "DESC")
      .addGroup("field_category_group", "OR")
      .addFilter("field_category.field_hide_in_listing", "0", "=", "field_category_group")
      .addFilter("field_category.field_hide_in_listing", null, "IS NULL", "field_category_group")
      .getQueryObject(),
  });

  return {
    props: {
      ...(await getGlobalElements(context)),
      content: contentObject.content,
      theme: contentObject.content.node.field_dark_banner,
      preFooter: contentObject.content.node.field_show_prefooter,
      meta: contentObject.content.node.metatag ? contentObject.content.node.metatag : null,
      canonical: path.entity.path ? path.entity.path : slug
    },

    revalidate: revalidateTimeout
  };
};
